import React, { useEffect } from "react";
import { firebaseApp, vapidKey } from "./firebaseConfig";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
} from "firebase/messaging";
import { toast } from "react-toastify";

import { useSubscribeAndSetToken } from "./page/Welcome/Welcome.helpers";

const useFcmProcess = () => {
  const { mutate: subscribeAndSetToken } = useSubscribeAndSetToken();

  return useEffect(() => {
    const { pathname } = new URL(window.location.href);
    if (!pathname.startsWith("/register")) {
      if ("Notification" in window) {
        // 크롬에서는 3번의 권한 요청을 취소 눌러도 차단으로 인식한다
        if (Notification.permission === "denied") {
          // ios에서 notification 객체 없어서 window에 객체 존재 여부 체크 안하면 에러 발생한다.
          // 추후에 토스트알림으로 메세지띄우고 클릭하면 권한 허용 요청하도록 구현하기
          alert(
            "알림 권한 설정이 차단되어 있습니다. 알림 권한을 허용해야 정상적인 서비스를 이용할 수 있습니다."
          );
        }
      }

      const messaging = getMessaging(firebaseApp);

      isSupported().then(() => {
        getToken(messaging, {
          vapidKey,
        })
          .then((token) => {
            if (token) {
              subscribeAndSetToken({ token });
            } else {
              console.log(
                "No registration token available. Request permission to generate one."
              );
            }
          })
          .catch((err) => {
            console.log("An error occurred while retrieving token. ", err);
          });

        onMessage(messaging, ({ data: { link, title } }) => {
          toast(
            <div
              onClick={() => {
                // 추후에 안내페이지로 이동시킬 것
                window.location.href = link;
              }}
            >
              {title}
            </div>
          );
        });
      });
    }
  }, []);
};

export default useFcmProcess;
